import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationResidenceTodoAppliedRuleApiService } from './organization-residence-todo-applied-rule-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResidenceTodoAppliedRuleApiService extends GeneratedOrganizationResidenceTodoAppliedRuleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
